import SliderLabeled from './slider-labeled';
export default SliderLabeled;
